import { render, staticRenderFns } from "./TeachingAndLearning.vue?vue&type=template&id=42de98be&scoped=true&"
import script from "./TeachingAndLearning.vue?vue&type=script&lang=js&"
export * from "./TeachingAndLearning.vue?vue&type=script&lang=js&"
import style0 from "./TeachingAndLearning.vue?vue&type=style&index=0&id=42de98be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42de98be",
  null
  
)

export default component.exports